import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL, companyId, MenuItemEndPoint } from "../../Api/api";

// Create an API slice using RTK Query
export const menuItemsApi = createApi({
  reducerPath: "menuItemsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
  }),
  tagTypes: ["MenuItem"],

  endpoints: (builder) => ({
    // Get all menu items with pagination
    getAllMenuItems: builder.query({
      query: ({ limit = 100, page = 1, categoryName = "", keyword = "" }) => {
        let url = `${MenuItemEndPoint}?companyId=${companyId}&limit=${limit}&page=${page}`;
        if (categoryName) {
          url += `&categoryName=${categoryName}`;
        }
        if (keyword) {
          url += `&keyword=${keyword}`;
        }
        return url;
      },
      providesTags: ["MenuItem"],
    }),

    // Get one menu item by ID
    getOneMenuItem: builder.query({
      query: (id) => `${MenuItemEndPoint}/${id}?companyId=${companyId}`,
      providesTags: ["MenuItem"],
    }),
  }),
});

// Export hooks for using these endpoints in components
export const { useGetAllMenuItemsQuery, useGetOneMenuItemQuery } = menuItemsApi;
